import { render, staticRenderFns } from "./NavFrame.vue?vue&type=template&id=4160f6c3"
import script from "./NavFrame.vue?vue&type=script&lang=js"
export * from "./NavFrame.vue?vue&type=script&lang=js"
import style0 from "./NavFrame.vue?vue&type=style&index=0&id=4160f6c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports